// extracted by mini-css-extract-plugin
export default {"contentBlock":"ProductionPage_contentBlock__rl6OI"};